import { stateKey } from './actions'

// Property filters
export const selectPropertyServiceFilter = (state) => state[stateKey].property.propertyServiceId
export const selectPropertyTypeFilter = (state) => state[stateKey].property.propertyTypeId
export const selectPropertyStatusFilter = (state) => state[stateKey].property.propertyStatusId
export const selectPropertyMainRegisterFilter = (state) => state[stateKey].property.propertyMainRegisterId
export const selectPropertyRegistryDepartmentKpuFilter = (state) => state[stateKey].property.propertyRegistryDepartmentKpuId

// Contact profile filters
export const selectContactProfilePropertyTypeFilter = (state) => state[stateKey].contactProfile.propertyTypeId
export const selectContactProfilePropertyServiceFilter = (state) => state[stateKey].contactProfile.propertyServiceId

// Location filters
export const selectLocationCountryFilter = (state) => state[stateKey].location.country
export const selectLocationCountyFilter = (state) => state[stateKey].location.county
export const selectLocationCityFilter = (state) => state[stateKey].location.city
export const selectLocationWiderAreaFilter = (state) => state[stateKey].location.widerArea
export const selectLocationQuarterFilter = (state) => state[stateKey].location.quarter
export const selectLocationIslandFilter = (state) => state[stateKey].location.island
